module.exports = __webpack_public_path__ + "static/media/upcoming1.695329fe.jpg";